module.exports = __webpack_public_path__ + "static/media/icon_24h.867635dc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon_24h.svg
// module id = 517
// module chunks = 0